import GpanelContactsTrashLabels from './gpanel-contacts-trash-labels';

export default function GpanelContactsTrashLabelsPage() {
  return <GpanelContactsTrashLabels />;
}
